export interface Partner {
  name: string;
  logoUrl: string | null;
  logoWordmark?: { text: string; colors: string[] };
  category: string;
  description: string;
  deal?: string;
  referralUrl: string;
}

export const partnersData: Partner[] = [
  {
    name: 'Google Workspace',
    logoUrl: null,
    logoWordmark: {
      text: 'Google Workspace',
      colors: ['#4285F4', '#EA4335', '#FBBC05', '#34A853'],
    },
    category: 'Productivity',
    description:
      'Google Workspace gives your team professional email, shared drives, Docs, Sheets, Meet, and more — all in one place. We help businesses set up and migrate to Workspace for a seamless, collaborative environment.',
    referralUrl: 'https://referworkspace.app.goo.gl/HVaU',
  },
  {
    name: 'ElevenLabs',
    logoUrl: 'https://11labs-nonprd-15f22c1d.s3.eu-west-3.amazonaws.com/0b9cd3e1-9fad-4a5b-b3a0-c96b0a1f1d2b/elevenlabs-logo-white.svg',
    category: 'AI & Voice',
    description:
      "ElevenLabs is the leading AI voice platform — generate lifelike voiceovers, clone voices, and create multilingual audio content in minutes. We integrate ElevenLabs into client projects that need AI-powered narration or voice automation.",
    referralUrl: 'https://try.elevenlabs.io/d8t4zgzffvva',
  },
  {
    name: 'Grasshopper',
    logoUrl: null,
    logoWordmark: {
      text: 'Grasshopper',
      colors: ['#6ABF4B'],
    },
    category: 'Business Phone',
    description:
      'Grasshopper is an automated business phone system that helps you manage calls, texts, extensions, and professional greetings from anywhere. We recommend it to businesses that want a polished, flexible phone presence without extra hardware.',
    referralUrl: 'https://referral.grasshopper.com/mzVVyL1',
  },
  {
    name: 'Bolt',
    logoUrl: 'https://bolt.new/static/bolt-logo.svg',
    category: 'AI Web Builder',
    description:
      'Bolt is the AI-powered web builder we use to design, prototype, and ship full-stack apps and websites fast — right in the browser. No setup, no boilerplate. Just describe what you want and Bolt builds it.',
    deal: '20% off for 3 months — waiting for you',
    referralUrl: 'https://bolt.cello.so/ftyaP8uWKhF',
  },
];
